import { render } from "./insurance_setting_index.vue?vue&type=template&id=e7409e32"
import script from "./insurance_setting_index.vue?vue&type=script&lang=js"
export * from "./insurance_setting_index.vue?vue&type=script&lang=js"

import "./insurance_setting_index.vue?vue&type=style&index=0&id=e7409e32&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__